<template>
    <div id="editor_noveloutline">
        <!-- 作品大纲 -->
        <div class="editor_noveloutline">
            <div class="editor_noveloutline_1">
                <div class="editor_noveloutline_2">生成灵感</div>
                <!-- v-if="editType !== 1" -->
                <!-- <div class="editor_noveloutline_3 cursor_1" @click="openTip">
                    <img src="@/assets/image/icon_tip.png" alt="">
                    参考格式
                </div> -->
            </div>
            <textLoading v-if="streamStatus"></textLoading>
            <div class="cursor_1" v-if="!streamStatus" @click="changeOutline">换一换</div>
            <div class="editor_noveloutline_4">
                <div class="cursor_1 copyText t-m-r-10" @click="copyInnterText">复制全部内容</div>
                <div class="editor_noveloutline_5">字数 {{ removeMarkdownTags(aiCreateContent) }}</div>
            </div>

        </div>
        <div class="editor_noveloutline1" ref="editorOutline1">

            <div class="editor_noveloutline1_1" v-if="streamStatus && noveloutline.length === 0">
                <el-input type="textarea" readonly :placeholder="handPlaceholder" v-model="aiCreateContent">
                </el-input>
            </div>
            <div class="editor_noveloutline1_2" v-if="!streamStatus && noveloutline.length > 0">
                <editorOutlineList :is-edit="isEditorMode" :editType="editType" :noveloutline="noveloutline"
                    @addNovel="addNovel"></editorOutlineList>
            </div>
        </div>
        <!-- <div class="editor_noveloutline2">
        </div> -->
        <!-- 停止生成按钮 -->
        <AIStopCreate :hide="streamStatus"></AIStopCreate>
        <!-- 参考格式弹框 -->
        <!-- <tipPopup ref="tipPopup" mode="集"></tipPopup> -->
        <LengthSettingPopup ref="lengthSetting" @curClick="novelSelectClick"></LengthSettingPopup>
        <textRequire ref="textRequire" requireTitle="灵感要求" placeholder="请输入您的灵感特定要求，如：种田文融入真假千金的元素 (如无要求，可不填)">
        </textRequire>
    </div>
</template>
<script>
import tipPopup from '@/components/tip_popup.vue'
import api from '@/api/api';
import HApi from '@/api/hottc'
import textRequire from '@/components/text_require.vue'// 要求
import textLoading from '@/components/text_loading.vue';
import editorOutlineList from '@/components/hottc/editor_outlineList.vue';
import LengthSettingPopup from '@/components/long_novel/LengthSettingPopup.vue';
import { EncryptionUtil } from '@/utils/encrypt'
import { copy } from '@/utils/utils'
import { marked } from 'marked'
import { EventBus } from '@/utils/eventBus'
export default {
    components: {
        tipPopup, textLoading, editorOutlineList, LengthSettingPopup, textRequire
    },
    data() {
        return {
            editType: null, //1我有大纲手动输入 2Ai生成 3编辑大纲 4续写章节
            ifheadEdit: false, //  true表示手动输入如：我有大纲和手动续写；false表示ai生成、编辑、续写章节
            ifSave: false, //是否保存
            outlineNum: 0, //大纲字数
            // 手动输入提示词
            handPlaceholder: '',
            handText: '',//手动输入内容
            noveloutline: [], //小说大纲
            outlineItem: '', //Ai生成大纲
            streamCapture: [-1, -1],
            textrequire: '',//作品要求
            isEditorMode: false, //false显示编辑 true显示保存
            checked: false, //全选、反选
            isAiCreate: false,//是否ai去生成 true进入页面立即生成，false 表示不会刷新页面就生成
            hideEditorBtn: false,//false 默认不隐藏， true隐藏
            curSelectedObj: {},
            novelResult:{},//小说详情
        }
    },
    created() {
        let editItem = JSON.parse(sessionStorage.getItem('rm_editItem'))
        console.log('大纲页面=', editItem)
        if (editItem) {
            this.editType = editItem.editType;
            this.isAiCreate = editItem.isAiCreate === true ? true : false;
            if (this.editType === 2) {
                if (editItem.isAiCreate) {
                    //这里改变状态，如果重新刷新了页面就会提示
                    editItem.isAiCreate = false
                    sessionStorage.setItem('rm_editItem', JSON.stringify(editItem))
                    // this.ifheadEdit = false
                    //首次ai生成大纲，进来可以先编辑
                    // this.isEditorMode = true
                    // this.ifSave = false
                    this.createOutline()
                } else {
                    this.$notify({
                        title: '提示',
                        message: '请使用换一换来生成AI大纲',
                        duration: 5000,
                        type: 'warning'
                    });
                }

            } else if (this.editType === 3) {
                // this.ifheadEdit = false
                this.getOutline()
            }
        } else {
            // this.$message.warning('不支持多开页面进行操作')
            // setTimeout(() => {
            //     window.location.href = 'about:blank'; // 跳转到空白页
            // }, 500);

        }
    },
    mounted() {
         let editItem = JSON.parse(sessionStorage.getItem('rm_editItem'))
         EventBus.$on('getRequire', (requirement) => {
            console.log('监听到了111111=', requirement)
            this.aiCreateContent = ''
            this.handText = ''
            this.noveloutline = []
            const params = {
                ...editItem,
                requirement: requirement || '无'
            }
            sessionStorage.setItem('rm_editItem', JSON.stringify(params))
            this.createOutline()
        })
    },
    beforeDestroy() {
        this.clearTimer()
        EventBus.$off('getRequire')
    },
    methods: {
        //销毁定时器
        clearTimer(status) {
            console.log('进来了销毁定时器')
            if (status) {
                this.isStop = true
                this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                this.parseToFormData()
            }
            this.mixinClearTimer()
        },
        parseToFormData() {
            // this.handText = this.aiCreateContent
            const text = this.aiCreateContent
            // 1. 分割灵感
            const inspirations = text.split(/(?=-->|--&gt;灵感[一二\d]+：)/g).filter(Boolean);
            console.log('分割几份=', inspirations)
            // 2. 解析每个灵感
            const obj = inspirations.map(part => {
                const item = {
                    outlineText: part.replace(/-->|->|--&gt;|-&gt;|#/g, '')
                };

                // 匹配所有项目
                const regex = /->\d+、([^：\n]+)[：]?[\s\n]*([\s\S]*?)(?=->\d+、\s*[^：\n]+|$)/g;
                let match;

                while ((match = regex.exec(part + '\n->8、结束')) !== null) {
                    const key = match[1].trim();
                    let value = match[2].trim();
                    console.log('key=',key)
                    console.log('value=',value)
                    // 简单的switch映射
                    switch (key) {
                        case '小说标题': item.novelName = value; break;
                        case '小说题材': item.typeName = value; break;
                        case '小说标签': item.labelNames = value; break;
                        case '文笔风格': item.style = value; break;
                        case '世界观': item.world = value; break;
                        case '金手指': item.goldfinger = value; break;
                        case '小说剧情': item.plot = value; break;
                    }
                }

                return item;
            });
            console.log('obj=', obj)
            this.noveloutline = obj
        },
        //换一换ai生成
        changeOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('rm_editItem'))
            this.$refs.textRequire.open('生成灵感',editItem.requirement)
        },
        //Ai生成大纲 和 换一换
        createOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('rm_editItem'))
            let data = {
                requirement: editItem.requirement
            }
            this.AIWrite({
                length: '灵感',
                djold: true,
                haveId: true,
                type: editItem.uid,
                data: data,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    sessionStorage.setItem('ifEditor', true)
                    this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                    localStorage.setItem('AICreateId', res.data)
                    // this.getStreamContent(res.data)
                    this.getComStreamContent(res.data, {
                        scrollRef: this.scrollRef,
                        success: () => {
                            this.parseToFormData()

                        }
                    })
                },
                warn: (res) => {
                    this.mixinClearTimer()
                    this.$message.warning(res.msg)
                },
                error: () => {
                    this.mixinClearTimer()
                }
            })
        },
        // 滚动到内容底部
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.editorOutline1;
                if (container) {
                    container.scrollTop = container.scrollHeight; // 设置滚动位置到底部
                }
            });
        },
        //获取大纲内容
        getOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('rm_editItem'))
            if (editItem.id) {
                HApi.subjectDetail(editItem.id).then(res => {
                    if (res.code === 200) {
                        this.aiCreateContent = res.data.content
                        this.parseToFormData()
                        const {requirement} =  res.data.params ? JSON.parse(res.data.params) : {}
                        console.log('获取灵感=',requirement)
                        editItem.requirement =  requirement || ''
                        sessionStorage.setItem('rm_editItem', JSON.stringify(editItem))
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }


        },

        // 复制正文
        async copyInnterText() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            const success = await copy(this.aiCreateContent);
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
        addNovel(item) {
            this.curSelectedObj = item
            delete this.curSelectedObj.outlineText
            this.$refs.lengthSetting.open()
        },
        //选择小说
        novelSelectClick(params) {
            if (params.item.length.includes('中') || params.item.length.includes('短')) {
                params.item.length = params.item.length.includes('中') ? '中长篇小说' : '短篇小说'
                this.$router.replace({ path: '/novel', query: { lgPage: '灵感', lgItem: this.curSelectedObj, length: params.item.length } })
            } else {
                this.$router.push({ path: '/longNovel', query: { lgPage: '灵感', lgItem: this.curSelectedObj } });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#editor_noveloutline {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    position: relative;
    display: flex;
    flex-direction: column;
}

.editor_noveloutline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    height: 67px;
    border-bottom: 1px solid #E6EBF0;
}

.editor_noveloutline_1 {
    display: flex;
    align-items: center;
}

.editor_noveloutline_2 {
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    margin-right: 10px;
}

.editor_noveloutline_3 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
}

.editor_noveloutline_3 img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.editor_noveloutline_4 {
    display: flex;
    align-items: center;
}

.editor_noveloutline_5 {
    font-size: 15px;
    color: #444444;
}

.editor_noveloutline_6 {
    font-size: 15px;
    color: var(--tech-primary);
    margin-left: 20px;
}

.editor_noveloutline1 {
    // height: calc(100% - 138px);
    flex: 1;
    overflow-y: auto;
    padding: 25px 0 25px 40px;
    position: relative;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover();
    }
}

.editor_noveloutline1_1 {
    height: 100%;

    ::v-deep(.el-textarea__inner) {
        @include scrollbar();

        &:hover {
            @include scrollbar_hover();
        }
    }
}

.editor_noveloutline1_1 .el-textarea {
    height: 100%;
}

.editor_noveloutline1_1 .el-textarea .el-textarea__inner {
    height: 100%;
    width: 100%;
}

.editor_noveloutline1 .el-textarea__inner {
    width: 100%;
    min-height: 100px;
    background-color: transparent;
    border: none;
    resize: none;
    outline: none;
    box-shadow: none;
    padding: 0;
}

.editor_noveloutline2 {
    height: 69px;
    border-top: 1px solid #E6EBF0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_noveloutline2_1 {
    padding: 10px 15px;
    background: #AAAAAA;
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
    cursor: pointer;
}

.editor_noveloutline2_2 {
    background: var(--tech-primary);
}

.editor_noveloutline2_3 {
    display: flex;
}

.editor_noveloutline2_4 {
    width: 167px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    border-radius: 8px;
    border: 1px solid var(--tech-primary);
    font-size: 17px;
    color: var(--tech-primary);
    cursor: pointer;
    margin-right: 20px;
}

.editor_noveloutline2_5 {
    background-color: var(--tech-primary);
    color: #FFFFFF;
    border: none;
}

.editor_noveloutline2_4:last-child {
    margin-right: 0;
}

.checked {
    position: absolute;
    right: 20px;
    top: 5px;
    z-index: 99;
}

.copyText {
    height: 36px;
    padding: 0 10px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    /* background-color: var(--tech-primary); */
    /* color: #fff; */
    /* border: 1px solid var(--tech-primary); */
    color: var(--tech-primary);
    font-size: 15px;
    cursor: pointer;
}
</style>